import {Subscription} from "rxjs";
import {FormsModule} from "@angular/forms";
import {DatePipe, NgClass} from "@angular/common";
import {NavigationStart, Router} from "@angular/router";
import {Component, ElementRef, EventEmitter, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {NgbActiveModal, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

import {DealParticipantType} from "@numizmat/enumerations";
import {ForceRepaintDirective} from "@numizmat/directives";
import {ConversationMessageApiService} from "@numizmat/services/core";
import {InsertConversationMessageRequest, ConversationMessageResponse} from "@numizmat/services-models/core";

@Component({
  selector: 'nz-conversation-conversation-conversation-message-modal',
  imports: [
    DatePipe,
    FormsModule,
    NgClass,
    NgbTooltip,
    ForceRepaintDirective
  ],
  templateUrl: './conversation-message-modal.component.html',
  styleUrl: './conversation-message-modal.component.scss'
})
export class ConversationMessageModalComponent implements OnInit, OnDestroy {
  @ViewChild('messagesContainer') messagesContainer: ElementRef | undefined;

  private router: Router = inject(Router);
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private conversationMessageApiService: ConversationMessageApiService = inject(ConversationMessageApiService);

  private subs: Subscription = new Subscription();

  protected adId!: string;
  protected adTitle!: string;
  protected adPrice!: number;
  protected interlocutorUsername!: string;
  protected dealParticipantType!: DealParticipantType;

  protected messageContent: string = '';
  protected loadingData: boolean = true;
  protected loadingSubmit: boolean = false;
  protected messages: ConversationMessageResponse[] = [];

  protected onSubmitMessage: EventEmitter<string> = new EventEmitter<string>();

  protected readonly DealParticipantType = DealParticipantType;

  public ngOnInit(): void {
    this.getAllMessages();
    this.crateRouterChangeSubscription();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  protected onSubmit(): void {
    this.messageContent = this.messageContent.trim();
    if (!this.messageContent) {
      this.messageContent = '';
      return;
    }
    this.loadingSubmit = true;
    const request: InsertConversationMessageRequest = {
      adId: this.adId,
      content: this.messageContent
    };
    this.conversationMessageApiService.insertConversationMessage(request).subscribe({
      next: (response: ConversationMessageResponse) => {
        this.loadingSubmit = false;
        this.messages.push(response);
        this.scrollToBottom();
        this.onSubmitMessage.emit(this.messageContent);
        this.messageContent = '';
      }
    });
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }

  private getAllMessages(): void {
    this.conversationMessageApiService.getAllConversationMessages(this.adId).subscribe({
      next: (response: ConversationMessageResponse[]) => {
        this.loadingData = false;
        this.messages = response;
        this.scrollToBottom();
      }
    });
  }

  private scrollToBottom(): void {
    if (this.messagesContainer) {
      setTimeout(() => {
        this.messagesContainer?.nativeElement.scrollTo({
          top: this.messagesContainer.nativeElement.scrollHeight,
          behavior: 'smooth',
        });
      }, 10);
    }
  }

  private crateRouterChangeSubscription() {
    const subscription: Subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.closeModal();
      }
    });
    this.subs.add(subscription);
  }
}
